export const currentQuater = () => {
  const today = new Date();
  const month = today.getMonth();
  const CurrentYear = today.getFullYear();

  let year = CurrentYear + 1;
  let quarter = "";

  if (month < 3) {
    year = CurrentYear - 1;
    quarter = `Q4-${year}-${CurrentYear}`;
  } else if (month < 6 && month > 2) {
    quarter = `Q1-${CurrentYear}-${year}`;
  } else if (month < 9 && month > 5) {
    quarter = `Q2-${CurrentYear}-${year}`;
  } else if (month < 12 && month > 8) {
    quarter = `Q3-${CurrentYear}-${year}`;
  }

  return quarter;
};

export function getQuarterEndDate() {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();

  let endMonth;

  if (month < 3) {
    endMonth = 2;
  } else if (month < 6 && month > 2) {
    endMonth = 5;
  } else if (month < 9 && month > 5) {
    endMonth = 8;
  } else if (month < 12 && month > 8) {
    endMonth = 11;
  }

  return new Date(year, endMonth + 1, 0);
}

// Function to get the previous quarter
export function getPreviousQuarter(quarter) {
  const [q, yearStart, yearEnd] = quarter.split("-");
  const yearStartNum = parseInt(yearStart);
  const yearEndNum = parseInt(yearEnd);

  if (q === "Q1") {
    return `Q4-${yearStartNum - 1}-${yearEndNum - 1}`;
  } else {
    const quarterNum = parseInt(q.slice(1));
    return `Q${quarterNum - 1}-${yearStartNum}-${yearEndNum}`;
  }
}
